exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".order__cell[data-content][data-v-57559d2a]:after {\n  display: inline-block;\n  float: left;\n  margin-right: 0.3125rem;\n  content: attr(data-content) \":\";\n}\n@media (min-width: 1024px) {\n.order__cell[data-content][data-v-57559d2a]:after {\n    display: none;\n}\n}\n.print-button[data-v-57559d2a] {\n  padding-top: 0.75rem;\n  padding-bottom: 0.75rem;\n}\n@media (min-width: 1024px) {\n.print-button[data-v-57559d2a] {\n    padding-left: 1.25rem;\n    padding-right: 1.25rem;\n    padding-top: 0.3125rem;\n    padding-bottom: 0.3125rem;\n}\n}\n", ""]);

// exports
